<template>
  <b-card title="Firma Bilgisi">
    <b-list-group>
      <b-list-group-item>
        <div class="font-weight-bold text-primary">
          Firma Adı
        </div>
        <div>
          {{ customer.company }}
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <div class="font-weight-bold text-primary">
          Yetkili Kişi
        </div>
        <div>
          {{ customer.name }}
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <div class="font-weight-bold text-primary">
          Telefon
        </div>
        <div>
          {{ customer.phone }}
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <div class="font-weight-bold text-primary">
          E-Posta
        </div>
        <div>
          {{ customer.email }}
        </div>
      </b-list-group-item>
    </b-list-group>
    <b-button
      class="mt-2"
      variant="primary"
      block
      :to="'/admin/customers/view/' + dataItem.id_customers"
    >
      <FeatherIcon icon="EyeIcon" />
      Müşteri Kartını Görüntüle
    </b-button>
  </b-card>
</template>

<script>
import {
  BCard, BListGroup, BListGroupItem, BButton,
} from 'bootstrap-vue'

export default {
  name: 'LicenceCustomer',
  components: {
    BCard,
    BListGroup,
    BListGroupItem,
    BButton,
  },
  computed: {
    dataItem() {
      return this.$store.getters['licenses/dataItem']
    },
    customer() {
      return this.$store.getters['customers/dataItem']
    },
  },
}
</script>
